import CompletedMeasurement from './CompletedMeasurement';

export default CompletedMeasurement;
